import { requestConstantsMaker } from '../helper';
export const LOGIN = requestConstantsMaker('LOGIN');